export default function PHP_boolval() {
  return (
    <div>
      <h1>PHP_boolval</h1>
    </div>
  );
}
